module.exports = __webpack_public_path__ + "media/images/pages/school/diploma-44f44c2ba4ac64e000e5c3aec2ff6376.png";